import { tw } from "@careinfo/tailwind";
import Cleave from "cleave.js/react";
import { useFieldArray } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import CrossIcon from "../../Icons/CrossIcon";
import ComboboxInput from "../Reusable/ComboboxInput";
import FormDatePicker from "../Reusable/DateField";
import FileUpload from "../Reusable/FileUpload";
import ItemsComboboxInput from "../Reusable/ItemsComboboxInput";
import NpDatePicker from "../Reusable/NepaliDatePicker";
import NumberField from "../Reusable/NumberField";
import TextAreaField from "../Reusable/TextAreaField";
import TextField from "../Reusable/TextField";

const Form = (props: any) => {
  const {
    control,
    register,
    errors,
    getValues,
    setValue,
    clearErrors,
    companyData,
    isDraft = true,
    watch,
    setOpenUserFormPopup,
    setIsOpenItemsPopup,
    setPartyValue,
  } = props;

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  const handleAddRow = () => {
    append({
      account: "",
      quantity: "",
      hs_code: "",
      rate: "",
      amount: "",
      discount: "",
    });
  };

  return (
    <div className={tw`px-4`}>
      <div className={tw`grid grid-cols-4 mb-1 gap-x-4`}>
        <NpDatePicker
          label="Miti"
          name="voucher_date"
          disabled={!isDraft}
          value={watch("voucher_date")}
          setValue={setValue}
          disableFuture={true}
          error={errors?.voucher_date}
        />
        <FormDatePicker
          label="Date"
          name="voucher_date"
          disabled={!isDraft}
          control={control}
        />
        <TextField
          control={control}
          name="bill_number"
          label="Purchase Bill No."
          placeholder=""
          disabled={!isDraft}
        />
        <div className={tw`w-full flex items-start justify-center space-x-1`}>
          <ComboboxInput
            url={APIS.USER}
            queryKey="supplier"
            label={"Supplier Name"}
            props={{
              is_supplier: true,
            }}
            register={register("party")}
            errors={errors?.party}
            setValue={setValue}
            disabled={!isDraft}
            name={"party"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <button
            className={tw`border px-3 py-1 text-xl leading-0 relative top-7 bg-[#EEF5F4] focus:outline-none`}
            type="button"
            onClick={() => setOpenUserFormPopup((prev) => !prev)}
          >
            +
          </button>
        </div>
      </div>
      <div className={tw`grid grid-cols-2 gap-x-4 mt-2 w-full `}>
        <div
          className={tw`grid  gap-x-2`}
          style={{ gridTemplateColumns: "60px 120px 1fr" }}
        >
          <p className={tw`font-semibold`}>S.N</p>
          <p className={tw`font-semibold`}>HS Code</p>
          <p className={tw`font-semibold`}>
            {companyData?.type === "Trading" ? "Items" : " Description"}
          </p>
        </div>
        <div className={tw`grid grid-cols-5 w-full gap-x-4`}>
          <p className={tw`font-semibold`}>Quantity</p>
          <p className={tw`font-semibold`}>Unit</p>
          <p className={tw`font-semibold`}>Rate</p>
          <p className={tw`font-semibold`}>Amount</p>
          <p className={tw`font-semibold`}>Discount</p>
        </div>
      </div>
      <div id="sub-product">
        {fields.map((field: any, index: any) => {
          return (
            <div key={index}>
              <div className={tw`flex  mb-1  gap-x-4 w-full`}>
                <div
                  className={tw`w-full flex items-start justify-center space-x-2`}
                >
                  <input
                    disabled={true}
                    value={index + 1}
                    className={tw`bg-[#EEF5F4] p-2 w-14 h-9 mt-2`}
                    {...register(`items.${index}.serial_number`)}
                  />
                  <div className={tw`max-w-20`}>
                    <TextField
                      control={control}
                      name={`items.${index}.hs_code`}
                      placeholder="HS Code"
                      disabled={!isDraft}
                    />
                  </div>
                  <ItemsComboboxInput
                    url={APIS.PRODUCT}
                    queryKey={"inventory-info"}
                    register={register(`items.${index}.account`)}
                    errors={errors?.items?.[index]?.account}
                    name={`items.${index}.account`}
                    setValue={setValue}
                    props={{
                      is_active: true,
                    }}
                    value={watch(`items.${index}.account`)}
                    HsCode={`items.${index}.hs_code`}
                    taxable={`items.${index}.is_taxable`}
                    unit={`items.${index}.unit`}
                    placeholder={"Search Items"}
                    clearErrors={clearErrors}
                    disabled={!isDraft}
                  />
                  <button
                    className={tw`border px-3 py-1 text-xl leading-0 relative top-2  bg-[#EEF5F4] `}
                    type="button"
                    onClick={() => {
                      setIsOpenItemsPopup((prev) => !prev);
                      setPartyValue(`${index}`);
                    }}
                  >
                    +
                  </button>
                </div>
                <div className={tw`flex w-full  gap-x-2 `}>
                  <div className={tw`grid grid-cols-5 gap-x-4 w-full`}>
                    <NumberField
                      value={getValues(`items.${index}.quantity`)}
                      register={register(`items.${index}.quantity`)}
                      errors={errors?.items?.[index]?.quantity}
                      setValue={(name, value) => {
                        setValue(name, value);

                        const quantity = Number(value) || 0;
                        const rate =
                          Number(getValues(`items.${index}.rate`)) || 0;
                        const amount =
                          Number(getValues(`items.${index}.amount`)) || 0;

                        if (rate && quantity) {
                          setValue(
                            `items.${index}.amount`,
                            (rate * quantity).toFixed(2)
                          );
                        } else if (amount && quantity) {
                          setValue(
                            `items.${index}.rate`,
                            (amount / quantity).toFixed(2)
                          );
                        } else {
                          setValue(`items.${index}.amount`, "");
                          setValue(`items.${index}.rate`, "");
                        }
                      }}
                      clearErrors={clearErrors}
                      disabled={!isDraft}
                    />
                    <TextField
                      control={control}
                      name={`items.${index}.unit`}
                      placeholder="Unit"
                      disabled={true}
                    />
                    <NumberField
                      value={getValues(`items.${index}.rate`)}
                      register={register(`items.${index}.rate`)}
                      errors={errors?.items?.[index]?.rate}
                      delimiter=","
                      setValue={(name, value) => {
                        setValue(name, value);
                        const quantity =
                          Number(getValues(`items.${index}.quantity`)) || 0;

                        if (name.endsWith(".rate")) {
                          const amount = quantity * (Number(value) || 0);
                          setValue(`items.${index}.amount`, amount);
                        }
                      }}
                      clearErrors={clearErrors}
                      disabled={!isDraft}
                    />

                    <NumberField
                      value={getValues(`items.${index}.amount`)}
                      register={register(`items.${index}.amount`)}
                      errors={errors?.items?.[index]?.amount}
                      delimiter=","
                      setValue={(name, value) => {
                        setValue(name, value);
                        const quantity =
                          Number(getValues(`items.${index}.quantity`)) || 0;

                        if (name.endsWith(".amount")) {
                          const rate =
                            quantity > 0 ? (Number(value) || 0) / quantity : 0;
                          setValue(`items.${index}.rate`, rate);
                        }
                      }}
                      clearErrors={clearErrors}
                      disabled={!isDraft}
                    />

                    <NumberField
                      value={getValues(`items.${index}.discount`)}
                      register={register(`items.${index}.discount`)}
                      errors={errors?.items?.[index]?.discount}
                      setValue={setValue}
                      delimiter=","
                      clearErrors={clearErrors}
                      disabled={!isDraft}
                      onKeyDown={(e) => {
                        if (
                          e.key === "Tab" &&
                          index === fields.length - 1 &&
                          !e.shiftKey
                        ) {
                          e.preventDefault();
                          handleAddRow();
                          setTimeout(() => {
                            const newRowInput =
                              document.querySelector<HTMLInputElement>(
                                `input[name="items.${fields.length}.account"]`
                              );
                            newRowInput?.focus();
                          }, 0);
                        }
                      }}
                    />
                  </div>
                  <button
                    type="button"
                    className={tw`rounded p-1 h-8 mt-2   border border-gray-400 text-xs`}
                    disabled={index === 0 || !isDraft}
                    onClick={() => remove(index)}
                  >
                    <CrossIcon />
                  </button>
                </div>
              </div>
              <hr />
            </div>
          );
        })}
        {errors?.items?.root?.message && (
          <span
            className={tw`text-red-500 text-xs flex items-center gap-x-1 mt-2`}
          >
            <span className={tw`block`}>
              {errors.items.root.message as string}
            </span>
          </span>
        )}
        <div className={tw`w-full flex justify-start  mt-2`}>
          <button
            type="button"
            disabled={!isDraft}
            className={tw`rounded p-1 mb-1 border border-gray-400 text-xs`}
            onClick={() => handleAddRow()}
          >
            Add Row
          </button>
        </div>
        <div
          className={tw` w-[350px]  -mt-4  ml-auto flex items-center justify-between p-2 bg-[#EEF5F4] rounded-lg`}
        >
          <div className={tw`flex flex-col gap-y-2`}>
            <p>Items Value</p>
            <p>Total Discount</p>
            <p>Non Taxable Amount</p>
            <p>Taxable Amount</p>
            <div className={tw`flex items-center gap-x-2`}>
              <span>VAT</span>
              <Cleave
                type="text"
                className={tw`w-8 focus:outline-none bg-white px-1 text-center `}
                value={getValues("tax_rate")}
                autoComplete="off"
                disabled={!isDraft}
                onBlur={(e) => clearErrors("tax_rate")}
                onChange={(e) => setValue("tax_rate", e.target.value)}
                options={{
                  numeral: true,
                  numeralDecimalMark: ".",
                  numeralDecimalScale: 0,
                  numeralPositiveOnly: true,
                  delimiter: "",
                }}
              />
              %
            </div>
            <p className={tw`font-semibold`}>Total Amount</p>
          </div>
          <div className={tw`flex flex-col gap-y-2 text-right`}>
            <p>
              {Number(getValues("items_value")).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
            <p>
              {Number(getValues("total_discount")).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
            <p>
              {Number(getValues("non_taxable_amount")).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
            <p>
              {Number(getValues("taxable_amount")).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
            <p>
              {Number(getValues("vat_tax_amount")).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
            <p className={tw`font-semibold`}>
              {Number(getValues("total_amount")).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          </div>
        </div>
      </div>
      <div className={tw`grid grid-cols-2 gap-x-6`}>
        <FileUpload
          label="Attachment"
          register={register("attachment")}
          watch={watch}
          errors={errors}
          disabled={!isDraft}
          setValue={setValue}
        />
        <TextAreaField
          label="Narration"
          control={control}
          disabled={!isDraft}
          name={"narration"}
          placeholder="Write notes here..."
        />
      </div>
    </div>
  );
};

export default Form;
